(() => {
  const initialize = (root) => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const cards = [...root.querySelectorAll('[data-product-card]')];
    const filterButtons = [...root.querySelectorAll('[data-filter]')];
    const showAll = root.querySelector('[data-show-all]');
    const count = root.querySelector('[data-filter-count]');
    const applyFilter = (filter) => {
      let visible = 0;
      cards.forEach((card) => {
        const match = filter === 'all' || (filter === 'featured' ? card.dataset.featured === 'true' : card.dataset.kind === filter);
        card.hidden = !match;
        if (match) visible++;
      });
      filterButtons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.filter === filter)));
      count.textContent = `${visible} ${visible === 1 ? 'modelo' : 'modelos'}`;
      showAll.hidden = filter === 'all';
    };
    root.querySelector('[data-filter-bar]').hidden = false;
    applyFilter('featured');
    filterButtons.forEach((button) => button.addEventListener('click', () => applyFilter(button.dataset.filter)));
    showAll.addEventListener('click', () => {
      applyFilter('all');
      const button = root.querySelector('[data-filter="all"]');
      button.focus({ preventScroll: true });
      root.querySelector('.rbl-filter-bar').scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    });
    root.querySelectorAll('[data-choose-filter]').forEach((link) => link.addEventListener('click', () => applyFilter(link.dataset.chooseFilter)));
    const updateCampaign = () => {
      const start = Date.parse(root.dataset.start);
      const end = Date.parse(root.dataset.end);
      const now = Date.now();
      const active = Number.isFinite(start) && Number.isFinite(end) && now >= start && now <= end;
      // The class switches the Cyber palette; outside the campaign the landing is plain brand.
      root.classList.toggle('rbl--cyber', active);
      root.querySelectorAll('[data-campaign-only]').forEach((element) => { element.hidden = !active; });
    };
    updateCampaign();
    // A visitor who keeps the page open across the deadline also sees the campaign end.
    const campaignTimer = setInterval(() => {
      if (!root.isConnected) { clearInterval(campaignTimer); return; }
      updateCampaign();
    }, 60000);
    root.querySelectorAll('[data-cart-form]').forEach((form) => {
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        const button = form.querySelector('button');
        if (button.disabled) return;
        const status = form.closest('[data-product-card]').querySelector('[data-cart-status]');
        const originalHTML = button.innerHTML;
        button.disabled = true;
        button.textContent = 'Agregando…';
        status.textContent = '';
        try {
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
            method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' }
          });
          const data = await response.json();
          if (!response.ok) throw new Error(data.description || 'No pudimos agregarlo. Revisa su disponibilidad en la ficha.');
          window.location.assign(`${window.Shopify?.routes?.root || '/'}cart`);
        } catch (error) {
          status.textContent = error.message || 'No pudimos conectarnos. Intenta nuevamente.';
          button.disabled = false;
          button.innerHTML = originalHTML;
        }
      });
    });
  };
  const scan = (container = document) => container.querySelectorAll('[data-robot-landing]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan());
  else scan();
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();
